import { api } from '../lib/api'

export type WalletStake = {
  id: string
  amount_pixe: string
  purpose: string
  locked_until: string
  is_unlockable: boolean
  status: 'active' | 'unstaked'
}

export type WalletStakesSummary = {
  available_pixe: string
  staked_pixe_total: string
  active_stakes_count: number
  next_unlock_at: string | null
}

export type WalletStakesListResponse = {
  summary: WalletStakesSummary
  stakes: WalletStake[]
}

export type CreateStakePayload = {
  amount_pixe: string
  lock_seconds?: number
  locked_until?: string
  purpose?: string
  metadata?: Record<string, any>
}

export async function listStakes() {
  const { data } = await api.get<WalletStakesListResponse>('/api/wallet/stakes/')
  return data
}

export async function createStake(payload: CreateStakePayload) {
  const { data } = await api.post<{ stake: WalletStake; summary: WalletStakesSummary }>('/api/wallet/stakes/', payload)
  return data
}

export async function unstakeStake(id: string) {
  const { data } = await api.post<{ stake: WalletStake; summary: WalletStakesSummary }>(`/api/wallet/stakes/${id}/unstake/`, {})
  return data
}

export async function verifyStake(params: { purpose?: string; min_pixe: string }) {
  const { data } = await api.get<{ ok: boolean; matched_staked_pixe: string; required_pixe: string; details?: string[] }>(
    '/api/wallet/stakes/verify/',
    { params },
  )
  return data
}
